const AUTOLOGIN_PARAM = "autologin"

interface ServerData {
  user?: unknown
  settings?: {
    oauth: Array<{ url: string }>
  }
}

function readServerData(): ServerData {
  const el = document.getElementById("server-data")
  if (!el) {
    return {}
  }
  try {
    return JSON.parse(el.textContent || el.innerText) as ServerData
  } catch {
    return {}
  }
}

/** Same destination as the patched "Sign in" button: first OAuth provider with current URL as redirect. */
export function maybeAutologinRedirect(): void {
  const pageUrl = new URL(window.location.href)
  if (pageUrl.searchParams.get(AUTOLOGIN_PARAM) !== "true") {
    return
  }

  const data = readServerData()
  if (data.user) {
    return
  }

  const provider = data.settings?.oauth?.[0]
  if (!provider?.url) {
    return
  }

  const redirectTo = window.location.href
  window.location.replace(`${provider.url}?redirect=${encodeURIComponent(redirectTo)}`)
}
